import { NetworkStatus } from '@cbridge-utils/network';
import { ICoverageReportStore } from './coverageReport.interface';

export const coverageReportInitialState: ICoverageReportStore = {
  data: {},
  listNetworkStatus: NetworkStatus.None,
};
